export default __webpack_public_path__ + "static/media/stp-icon.d7cff135.svg";